module.exports = __webpack_public_path__ + "static/img/inspection-mission.325f424.png";